export default __webpack_public_path__ + "static/doodleTextBlack-3e674c4db1ec4b7540693342c6a5b337.svg";